import React from 'react';
import { ArrowLeft } from 'lucide-react';
import ConsentFormManager from '@/components/consent/ConsentFormManager';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/**
 * Consent Forms Settings Page
 * 
 * Allows clinic administrators to manage consent form templates
 * including creating, editing, and configuring required consents.
 */
const ConsentFormsPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="container mx-auto py-6 px-4 max-w-6xl">
      <div className="mb-6">
        <div className="mb-2 flex items-center gap-4">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)} className="h-9 w-9">
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-2xl font-bold tracking-tight">Consent Forms</h1>
        </div>
        <p className="text-muted-foreground">
          Manage consent form templates that patients must sign before appointments or telehealth calls.
        </p>
      </div>
      
      <ConsentFormManager />
    </div>
  );
};

export default ConsentFormsPage;










